<section class="wishlist-create-summary" aria-label="Podsumowanie wishlisty">
  <div class="summary-preview">
    <span class="summary-avatar" aria-hidden="true">
      {{ beneficiary()?.avatarLabel || 'W' }}
    </span>
    <span class="summary-preview-copy">
      <strong>{{ draft().title || 'Nowa wishlista' }}</strong>
      @if (draft().description.trim()) {
        <small>{{ draft().description }}</small>
      }
      <span
        >{{ beneficiary()?.displayName || 'Dla kogo' }} ·
        {{ giftCountLabel() }}</span
      >
      <span class="summary-track" aria-hidden="true"></span>
    </span>
  </div>

  <dl class="summary-rows">
    @for (row of rows(); track row.label) {
      <div>
        <dt>{{ row.label }}</dt>
        <dd>{{ row.value }}</dd>
      </div>
    }
  </dl>

  <p class="summary-hint">
    Udostępnianie skonfigurujesz w szczegółach wishlisty.
  </p>
</section>
